import { useSearchParams } from 'react-router-dom'

import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { clickCollectPOST } from 'featureSliced/shared/api/clickCollect/POST'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { Card } from 'featureSliced/features/Profile/Card'
import { ReceiptModal } from 'components/ReceiptModal'
import { SelectedProductsSlice } from 'featureSliced/shared/store/reducers/SelectedProductsReducer'

export type useCompleteSaferPayType = () => void

export const useCompleteSaferPayQRM = (): useCompleteSaferPayType => {
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const [searchParams, setSearchParams] = useSearchParams()

  // Store
  const { isAppInit } = useMySelector((state) => state.app)
  const { discardSelectedProducts } = SelectedProductsSlice.actions
  const clearBucket = QRMBucketSlice.actions.clearBucket

  // Variables
  const orderGuid = searchParams.get('orderGuid')
  const show_card = searchParams.get('show_card')
  const show_payment_variant = searchParams.get('show_payment_variant')

  // Functions
  const completeSaferPayQRM = async () => {
    try {
      if (isAppInit && orderGuid) {
        const isDefaultPayment = !show_card && !show_payment_variant
        const isCCUpdate = !show_card && show_payment_variant
        const isLoyaltyRefill = show_card && !show_payment_variant
        //
        if (isDefaultPayment) {
          openReceiptModal()
        }
        if (isCCUpdate) {
          // NOTE: credit card update is unavailable for safer pay so far
          //   completeCreditCardUpdate()
        }
        if (isLoyaltyRefill) {
          completeCardRefill()
        }
      }
    } catch (e) {
      searchParams.delete('orderGuid')
      searchParams.delete('show_card')
      searchParams.delete('show_payment_variant')
      setSearchParams(searchParams)
    }
  }

  const completeCardRefill = async () => {
    const success = await clickCollectPOST.refillCardComplete(null, orderGuid)
    if (success) {
      openModal({
        id: 'USER_CARD',
        title: '',
        components: [() => <Card />],
      })
    }
    searchParams.delete('show_card')
    searchParams.delete('orderGuid')
    setSearchParams(searchParams)
  }

  const openReceiptModal = async () => {
    openModal({
      id: 'RECEIPT_MODAL',
      // title: t('order.toMenu'),
      // onClose: handleReceiptModalClose,
      shouldHideCross: true,
      components: [
        ({ closeThisModal }) => (
          <ReceiptModal
            onCloseModal={(orderGuid?: string) => {
              closeThisModal()
              handleReceiptModalClose(orderGuid)
            }}
          />
        ),
      ],
    })
  }

  const handleReceiptModalClose = (orderGuid?: string) => {
    searchParams.delete('orderGuid')
    if (orderGuid) {
      searchParams.delete('table')
    }
    setSearchParams(searchParams)
    clearLocalStorage()
    dispatch(discardSelectedProducts()) // TODO: deprecated. remove
    dispatch(clearBucket())
  }

  const clearLocalStorage = () => {
    window.localStorage.removeItem('products_notes')
  }

  return completeSaferPayQRM
}
